import React, { useEffect, useState } from "react";
import { Button, FormControl, InputLabel, Select, TextField, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { SUPPORT } from "src/api/axios";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useMutation, useQuery } from "react-query";
import LoadingScreen from "src/components/LoadingScreen";
import { useLocation } from "react-router";
import { Card, MenuItem } from "@material-ui/core";
import InputAdornment from '@mui/material/InputAdornment';
import Send from "src/svgComponents/send";
const _ = require('lodash');

const EditSupportRequest = () => {
   const axiosPrivate = useAxiosPrivate();
   const { state } = useLocation();
   const { enqueueSnackbar } = useSnackbar();
   const supportData = state?.supportData;
   const navigate = useNavigate();

   const [loding, setLoding] = useState(false);
   const [colDir, setColDir] = useState("row");
   const [subject_id, setSubjectId] = useState('');
   const [authId, setAuthId] = useState('');
   const [message, setMessage] = useState('');

   useEffect(() => {
      setSubjectId(state?.supportData?.subject_data?._id)
      setFieldValue('subject_id', state.supportData.subject_data._id)
      setFieldValue('description', state.supportData.description)
   }, [state])

   const completedSchema = Yup.object().shape({
      subject_id: Yup.string().required('subject is required'),
      description: Yup.string().required('description is required'),
   });

   const formik = useFormik({
      initialValues: {
         subject_id: '',
         description: ''
      },
      validationSchema: completedSchema,
      onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
         const informationObj = {
            subject_id: values.subject_id,
            description: values.description,
         };

         await supportRequestUpdate(informationObj);
         setSubmitting(false);
      },
   });

   const { mutateAsync: supportRequestUpdate } = useMutation(
      async (data) => {
         return await axiosPrivate.put(SUPPORT.updateSupportRequest + state?.supportData?._id, data)
      },
      {
         onSuccess: ({ data }) => {
            enqueueSnackbar("Request update successfully ", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            navigate('/dashboard/support-ticket')
         },
         onError: (error) => {
            setLoding(false);
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }
            Object.keys(errorData).forEach((key) => {
               if (key === "subject") {
                  setFieldError("subject", errorData[key]);
               } else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );

   useEffect(() => {
      let mql = window.matchMedia('(max-width: 768px)');
      window.addEventListener("resize", () => {
         if (mql.matches) {
            setColDir("column")
         } else {
            setColDir("row")
         }
      })
   })
   const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps, setFieldTouched, resetForm } = formik;

   const handleFoodCategoryOnChange = (event) => {
      setSubjectId(event.target.value);
   };

   const { data: chatData, refetch } = useQuery(
      "locationData",
      async ({ signal }) => {
         return await axiosPrivate
            .get(SUPPORT.getChatMessage, {
               signal,
               params: { support_ticket_id: state?.supportData?._id },
            })
            .then((res) => res.data).catch((err) => {
               console.log(err);
            });
      },
      { refetchOnWindowFocus: false }
   );

   const auth_id = JSON.parse(localStorage.getItem('auth-storage'))
   useEffect(() => {
      setAuthId(auth_id?.state?.user?._id)
   }, [auth_id])

   const handleSendMessage = async (message) => {
      if (message !== '') {
         const messageObj = {
            message: message,
            support_ticket_id: supportData?._id,
            receiver_id: '6371e2f69a925fd5c209617e'
         }
         const response = await axiosPrivate.post(SUPPORT.sendMessage, messageObj)
         if (response.data.message) {
            setFieldValue('message', "");
            resetForm();
            refetch();
         }
      }
   }

   return (
      <>
         {loding ? <LoadingScreen /> : <>
            <FormikProvider value={formik}>
               <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                  <div className="container-fluid">
                     <div className="row row-cols-1 g-4">
                        <div className='col'>
                           <div className='user_edit_header'>
                              <h4 className="app_text_14_semibold mb-0">View Support Request</h4>
                           </div>
                        </div>
                        <div className='col'>
                           <Stack direction={colDir} spacing={2}>
                              <FormControl fullWidth className="mb-3">
                                 <InputLabel id="demo-simple-select-label">Subject</InputLabel>
                                 <Select
                                    disabled
                                    labelId="demo-simple-select-label"
                                    id="subject_id"
                                    label="Subject"
                                    value={subject_id}
                                    name="subject_id"
                                    onChange={(e) => {
                                       handleFoodCategoryOnChange(e);
                                       setFieldTouched("subject_id", true)
                                       setFieldValue("subject_id", e.target.value)
                                    }}
                                 >
                                    {
                                       state?.supportSubjectData?.map((result, i) => {
                                          return (
                                             <MenuItem value={result._id} key={i} >
                                                {result.name}
                                             </MenuItem>
                                          )
                                       })
                                    }
                                 </Select>
                                 {errors.subject_id && touched.subject_id && <Typography color="error">{errors.subject_id}</Typography>}
                              </FormControl>
                           </Stack>
                        </div>
                        <div className='col'>
                           <Stack direction={colDir} spacing={2}>
                              <TextField sx={{ "& .MuiInputBase-input.MuiOutlinedInput-input": { minHeight: '5.5rem' } }}
                                 label='Description' multiline name='description' autoComplete='off' fullWidth
                                 {...getFieldProps("description")} disabled
                                 error={Boolean(touched.description && errors.description)}
                                 helperText={touched.description && errors.description}
                              />
                           </Stack>
                        </div>
                     </div>
                     {/* <div className="col">
                        <div className="col-md-8 m-auto">
                           <Button
                              type="submit"
                              fullWidth
                              variant="contained"
                              className="my-3 text-white app_bg_primary app_text_16_semibold app_btn_lg"
                           >
                              Save Profile
                           </Button>
                        </div>
                     </div> */}
                  </div>
               </Form>
            </FormikProvider>

            {/* support chat */}
            {/* <Card>
               <h4 align="center">Support Chat</h4>
               <div className="card">
                  <div className="card-header">Admin</div>
                  <div className="card-body">
                     {
                        chatData?.length > 0 && chatData?.map((msg, i) => {
                           return (
                              <>
                                 <div className="col-lg-6">
                                    {
                                       msg.sender_id === authId ? (msg.type === 1) ? <div align="right" > <p>{msg.message}</p> </div> : ''
                                          : <div align="left" > <p>{msg.message}</p> </div>
                                       // msg.type === 1 ?
                                       //    <div align="right" > <p>{msg.message}</p> </div> : ""
                                    }
                                 </div>
                              </>
                           )
                        })
                     }
                  </div>
                  <div className="card-header">
                     <TextField
                        placeholder="Write Message..."
                        sx={{ "& .MuiInputBase-input.MuiOutlinedInput-input": { minHeight: '1.5rem' } }}
                        multiline
                        name='message'
                        type='text'
                        {...getFieldProps("message")}
                        onChange={(e) => setMessage(e.target.value)}
                        autoComplete='off'
                        fullWidth
                        InputProps={{
                           endAdornment: (
                              <InputAdornment position='end'>
                                 <Button onClick={(e) => handleSendMessage(message)} ><Send /></Button>
                              </InputAdornment>
                           )
                        }}
                     />
                  </div>
               </div>
            </Card> */}
         </>
         }
      </>
   )
}

export default EditSupportRequest